import { IdentityInternationalApi } from '@cmctechnology/phoenix-stockbroking-api-client';
import { createConfig } from '../configuration/configuration';
import { createApiConfig, createAxios, Interceptor } from './axiosFactory';

export const createIdentityInternationalApi = (interceptor?: Interceptor) => {
  const { apiUrl } = createConfig();
  const identityInternationalApi = new IdentityInternationalApi(createApiConfig(), apiUrl, createAxios(interceptor));
  return identityInternationalApi;
};
